import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import FootBand from '../FootBand/FootBand';
import { SOFT_IN, SHEET_OUT } from './SheetOverlay';
import styles from './SheetOverlay.module.css';

/**
 * The put-away sheet (PXP spec §12b, frame A3; `.ppstrip`): a tap outside a
 * share sheet about someone nearby leaves only its top edge — a 64px strip
 * flush to the foot, above the home-indicator area (D8), reading `People
 * nearby` in secondary 14.5px. It IS the sheet, clipped — same fill, corners
 * and soft shadow — so a tap on it brings the same sheet back. It does not
 * count and does not carry their face or name (§12b: you may be holding the
 * code out for someone else to scan). While it's up it holds the foot band in
 * its own colour, as a sheet does.
 *
 * @param {Object} p
 * @param {boolean} p.open
 * @param {string} [p.label='People nearby']
 * @param {Function} p.onClick - bring the sheet back
 */
const SheetStrip = ({ open, label = 'People nearby', onClick }) => {
  // The band stays until the strip's exit has finished, as the sheet's does
  const [shown, setShown] = useState(open);
  if (open && !shown) setShown(true);
  return (
    <>
      {shown ? <FootBand colour="var(--card-bg)" zIndex={1000} layer={1} /> : null}
      <AnimatePresence onExitComplete={() => setShown(false)}>
        {open ? (
          <motion.button
            type="button"
            className={styles.strip}
            onClick={onClick}
            initial={{ y: '100%', opacity: 0 }}
            animate={{ y: 0, opacity: 1, transition: SOFT_IN }}
            exit={{ y: '100%', transition: SHEET_OUT }}
          >
            <span>{label}</span>
          </motion.button>
        ) : null}
      </AnimatePresence>
    </>
  );
};

export default SheetStrip;
